module.exports = global["jQuery"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 1567
// module chunks = 14